import { SkeletonInline } from '@/common/components/SkeletonInline/SkeletonInline';
import { Translate } from '@/common/components/Translate/Translate';
import { IEWADetails } from '@/common/integrations/menhir/employee/salary/salary.types';
import {
  DateUtils,
  INTL_MONTH_DAY_SHORT_FORMAT,
  INTL_MONTH_SHORT_FORMAT,
  intlFormat,
} from '@/common/utils/date';
import { getPayrollRange } from '@/common/utils/ewa';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';
import i18n, { t } from 'i18next';

export function getWidgetContent(details?: IEWADetails) {
  if (!details) {
    return {
      primaryAmount: undefined,
      primaryLabel: <SkeletonInline />,
    };
  }

  const { from } = getPayrollRange(
    details.payday,
    details.lockPeriodBeforePayday
  );

  if (details.status === 'blocked') {
    return {
      primaryLabel: t('wallet.ewa_widget.blocked'),
    };
  }

  if (details.isBlockedDay) {
    const { from, to } = getPayrollRange(
      details.payday,
      details.lockPeriodBeforePayday
    );
    const formattedStartMonth = new Intl.DateTimeFormat(i18n.language, {
      month: 'short',
    }).format(from);

    return {
      primaryLabel: (
        <Translate
          i18nKey="wallet.ewa_widget.blocked_range"
          values={{
            from: `${formattedStartMonth} ${from.getDate()}`,
            to: to.getDate(),
          }}
          size="sm"
        />
      ),
    };
  }

  if (
    details.modules.includes('scheduling') &&
    details.scheduling &&
    details.scheduling.nextPayment.amount.amount > 0 &&
    details.scheduling.nextPayment.date
  ) {
    const nextPaymentDate = details.scheduling.nextPayment.date;

    return {
      primaryAmount: MoneyUtils.moneyToString(
        details.scheduling.nextPayment.amount,
        { integer: true }
      ),
      primaryLabel: t('wallet.ewa_widget.scheduled', {
        date: `${intlFormat(nextPaymentDate, {
          day: 'numeric',
        })} ${intlFormat(nextPaymentDate, INTL_MONTH_SHORT_FORMAT)}`,
      }),
    };
  }

  return {
    primaryAmount: MoneyUtils.moneyToString(details.availableAmount, {
      integer: true,
    }),
    primaryLabel: t('wallet.ewa_widget.available_until', {
      date: DateUtils.intlFormat(from, INTL_MONTH_DAY_SHORT_FORMAT),
    }),
  };
}
